/** Whether this device has agreed to the voice consent screen. Per device, not per account. */
const CONSENT_KEY = "tfwp.assistant.voiceConsent";

export function hasVoiceConsent(): boolean {
  try {
    return localStorage.getItem(CONSENT_KEY) === "1";
  } catch {
    return false;
  }
}

export function saveVoiceConsent(): void {
  try {
    localStorage.setItem(CONSENT_KEY, "1");
  } catch {
    /* private mode: ask again next time */
  }
}

/**
 * The client's yes to Ask sending their questions to the AI provider (App Store 5.1.2(i), and the same
 * words as the iPhone app's AIConsentSheet): "yes", "no" (Not now: the app's basic answers, and
 * nothing is sent), or null when they haven't been asked. Per device; forgotten at sign-out.
 */
export type AiConsent = "yes" | "no" | null;
export const AI_CONSENT_KEY = "tfwp.assistant.aiConsent";

export const AI_CONSENT_TEXT =
  "Your TFWP assistant sends your question and plan details to our AI provider to write answers. Your Social Security, bank and card numbers are removed first and never sent. Everything we keep is encrypted, and your information isn't used to train AI.";

export function aiConsent(): AiConsent {
  try {
    const v = localStorage.getItem(AI_CONSENT_KEY);
    return v === "yes" || v === "no" ? v : null;
  } catch {
    return null;
  }
}

export function saveAiConsent(value: "yes" | "no"): void {
  try {
    localStorage.setItem(AI_CONSENT_KEY, value);
  } catch {
    /* private mode: ask again next time */
  }
}
